import { Button, ButtonGroup, Tooltip } from "@shopify/polaris";
import { DeleteMajorMonotone } from "@shopify/polaris-icons";
import { get } from "lodash";
import React, { useCallback, useState } from "react";
import styled from "styled-components";

import { useAppContext } from "../../../context";
import { checkPlatform, checkRole, isPME_TEAM } from "../../../helper";
import useToggle from "../../../hooks/useToggle";
import { PLATFORMS, PLATFORM_FACEBOOK, STORE_STATUS } from "../../../variable";
import SuspenseComp from "../../shared/SuspenseComp";
import { MapActionProvider } from "../context";
import MoreActions from "./MoreActions";
import { SplitOrder } from "./SplitOrder";
import { Trash } from "./Trash";
import TiktokDuplicateOrder from "./tiktok-duplicate-order";
import TiktokMarkAsOrderLabel from "./tiktok-mark-as-order-label";
import TiktokMoreAction from "./titkok-more-action";
import MappingOrderUpdateQuantity from "./update-quantity";

const MapContainer = React.lazy(() => import("../components/MapContainer"));

const Container = styled.div``;

export const Actions = ({ item, actionCompleted, setDoAction, refetch }) => {
    // State
    const [open, toggleOpen] = useToggle(false);
    const [action, setAction] = useState(null);

    // Context
    const { currentUser } = useAppContext();
    const isPMETeam = isPME_TEAM(currentUser);
    const { isDesignLeader } = checkRole(currentUser);

    // Handle action
    const onAction = useCallback(
        (action) => {
            toggleOpen(true);
            setAction(action);
            setDoAction(true);
        },
        [toggleOpen],
    );

    const onClose = useCallback(() => {
        setAction(null);
        toggleOpen(false);
        setDoAction(false);
    }, [toggleOpen]);

    const handleCompleted = useCallback(() => {
        onClose();
        refetch && refetch();
    }, [onClose, refetch]);

    // Markup
    const props = {
        ids: item?.id ? [item.id] : [],
        onClose: onClose,
        open,
        isMoreAction: true,
        handleCompleted: actionCompleted,
        item,
    };

    const platform = item?.store?.platform;
    const platformFB = platform === PLATFORM_FACEBOOK;
    const isEtsy = platform === PLATFORMS.Etsy;

    const { isTiktok } = checkPlatform(platform);

    const showSplit =
        item?.quantity && parseInt(item.quantity) > 1 && platformFB;
    const actionsMarkup = {
        map: (
            // <MappingOrderActionPolaris
            //   open={open}
            //   toggleModal={onClose}
            //   item={item}
            //   onCompleted={handleCompleted}
            // />
            <MapContainer
                open={open}
                onCompleted={handleCompleted}
                onClose={onClose}
            />
        ),
        trash: <Trash {...props} />,
        splitOrder: (
            <SplitOrder {...props} item={item} onCompleted={handleCompleted} />
        ),
        updateQuantity: <MappingOrderUpdateQuantity {...props} onCompleted={handleCompleted}  />,

    };

    if (item) {
        item.variants =
            (item.variants &&
                item.variants.map((v) =>
                    v.legacyResourceId
                        ? {
                              ...v,
                              id: v.legacyResourceId,
                              attributes: v.selectedOptions.map((s) => ({
                                  ...s,
                                  option: s.value,
                              })),
                          }
                        : v,
                )) ||
            [];
    }

    const buttonMapMarkup =
        !isPMETeam || isStoreConnected(item) ? (
            <Button primary onClick={() => onAction("map")}>
                Map
            </Button>
        ) : (
            <Tooltip
                content={`Could not using this process, ${
                    item?.store?.status
                        ? `so Store status is ${item.store.status}`
                        : ""
                }`}
            >
                <Button primary disabled onClick={() => {}}>
                    Map
                </Button>
            </Tooltip>
        );

    return isDesignLeader ? null : (
        <Container>
            <ButtonGroup>
                {/* <Button primary onClick={() => onAction("map")}>
          Map
        </Button> */}
                {buttonMapMarkup}
                <Button children="Update Quantity" onClick={() => onAction("updateQuantity")}/>
                {showSplit && (
                    <Button
                        onClick={() => onAction("splitOrder")}
                        disabled={!showSplit}
                    >
                        Split
                    </Button>
                )}

                {isEtsy && <MoreActions record={item} refetch={refetch} />}

                {isTiktok && <TiktokMoreAction item={item} refetch={refetch} />}

                <Button
                    onClick={() => onAction("trash")}
                    icon={DeleteMajorMonotone}
                />
            </ButtonGroup>
            <MapActionProvider onCompleted={handleCompleted} item={item}>
                <SuspenseComp fallback={null}>
                    {actionsMarkup[action]}
                </SuspenseComp>
            </MapActionProvider>
        </Container>
    );
};

function isStoreConnected(mappingOrder) {
    const storeStatus = (get(mappingOrder, "store.status") || "")
        .trim()
        .toLowerCase();
    return storeStatus === (STORE_STATUS.Connected || "").toLowerCase();
}
